import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MapPin } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { IMAGES } from "../../lib/content";
import { useLang } from "../../lib/i18n";

export const Outlet = () => {
  const ref = useRef(null);
  const { tr } = useLang();
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section
      id="outlet"
      data-testid="outlet-section"
      ref={ref}
      className="relative overflow-hidden py-28 md:py-44"
    >
      {/* Parallax bg */}
      <motion.div style={{ y }} className="absolute inset-0 z-0 scale-125">
        <img
          src={IMAGES.outlet}
          alt="Area Outlet in Atelier"
          className="h-full w-full object-cover"
        />
      </motion.div>
      <div className="absolute inset-0 z-[1] bg-[#050505]/80" />
      <div className="absolute inset-0 z-[1] bg-gradient-to-r from-[#050505] via-[#050505]/60 to-transparent" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-2xl">
          <Reveal>
            <Overline>{tr("Area Outlet · In Atelier", "Outlet Area · In Atelier")}</Overline>
            <h2 className="mt-6 font-serif-display font-light text-4xl md:text-6xl leading-[1.02] tracking-tight text-white">
              {tr("Un'occasione preziosa,", "A precious opportunity,")}
              <span className="block italic text-gold">{tr("solo di persona.", "in person only.")}</span>
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-8 font-sans-ui font-light text-white/75 leading-relaxed text-base md:text-lg">
              {tr("All'interno di Atelier Divine è presente un'area ", "Inside Atelier Divine there is a dedicated ")}
              <span className="text-white">{tr("Outlet dedicata", "Outlet area")}</span>
              {tr(": una selezione esclusiva di modelli che potrai visionare, indossare e provare direttamente in negozio.", ": an exclusive selection of gowns you can view, wear and try on directly in store.")}
            </p>
            <p className="mt-5 font-sans-ui font-light text-white/60 leading-relaxed max-w-xl">
              {tr(
                "Nessun acquisto online: crediamo che un abito così importante meriti di essere vissuto dal vivo, con la nostra consulenza dedicata. Ti aspettiamo per scoprirla.",
                "No online purchases: we believe a dress this important deserves to be experienced in person, with our dedicated guidance. We look forward to showing it to you."
              )}
            </p>
          </Reveal>
          <Reveal delay={0.25}>
            <div className="mt-9 inline-flex items-center gap-3 border border-white/15 px-5 py-3">
              <MapPin size={16} className="text-gold" />
              <span className="font-sans-ui text-xs uppercase tracking-[0.2em] text-white/80">
                Via Ampère 63 · Comiso (RG)
              </span>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
